import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('ui-product-approvals', {
  library: 'ui-product-approvals',
});
